<template>
    <label class="custom-control custom-radio" v-if="isVisible">
        <input :value="value"
               :checked="modelValue.value === value"
               :id="id + '_' + value"
               :name="name"
               class="custom-control-input input"
               type="radio"
               @change="updateInput"
        >

        <label :for="id + '_' + value" class="custom-control-label">
            <span class="description">
                <span class="text-description" v-html="label">
                </span>
            </span>
        </label>
    </label>
    <!--<label class="custom-control custom-radio" v-else>-->
        <!--<label :for="id + '_' + value" class="custom-control-label unavailable">-->
            <!--<span class="description">-->
                <!--<span class="text-description" v-html="label">-->
                <!--</span>-->
                <!--<span class="text-unavailable">N'est pas disponible pour votre pays</span>-->
            <!--</span>-->
        <!--</label>-->
    <!--</label>-->
</template>
<script>
    import store from '../../store';
    import {mapState, mapActions, mapGetters} from 'vuex';

    const OrderInputCarrier = {
        name: 'ponroy-order-input-carrier',
        store,
        model: {
            prop: 'modelValue'
        },
        props: {
            value: {
                type: String,
            },
            modelValue: {
                type: Object,
            },
            countries: {
                type: Array,
                required: true,
            },
            id: {
                required: true,
            },
            name: {
                required: true,
            },
            label: {
                required: true,
            },
            isColissimo: {
                required: true,
            },
            isRelay: {
                required: true,
            }
        },
        data: function () {
            return {
                isVisible: true,
                isLoading: true,
            }
        },
        methods: {
            updateInput() {
                this.$emit('input', { value : this.value, isRelay : this.isRelay })
            }
        },
        computed: {
            ...mapGetters('order', ['shippingAddress']),
        },
        watch: {
            shippingAddress(value) {
                let shippingAddress = value;
                let flag = false;

                if (shippingAddress) {
                    this.isLoading = true;
                    this.countries.forEach(function(element) {
                        if (shippingAddress.country.id === element.id) {
                            flag = true;
                        }
                    });
                }

                this.isVisible = true === flag;
                this.isLoading = false;
            },
        }
    };

    export default OrderInputCarrier;
</script>

<style>
    .custom-control-label.unavailable:before {
        display: none;
    }

    .text-unavailable {
        position: absolute;
        background: #e7eaec;
        left: 2px;
        right: 2px;
        bottom: 0px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/OrderInputCarrier.vue